"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VIcon_vue_1 = __importDefault(require("./VIcon.vue"));
exports.default = vue_1.default.extend({
    name: "v-button",
    components: { VIcon: VIcon_vue_1.default },
    props: {
        color: {
            type: String,
            default: "success"
        },
        icon: {
            type: String,
            default: ""
        },
        iconPosition: {
            type: String,
            default: "left"
        },
        outline: {
            type: Boolean,
            default: false
        },
        displayLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isLoading: function () {
            return this.$store.state.isLoading;
        }
    }
});
